import { jsx as _jsx } from "react/jsx-runtime";
import MUIHidden from '@material-ui/core/Hidden';
export const Hidden = (props) => (_jsx(MUIHidden, Object.assign({}, props)));
export default MUIHidden;
//# sourceMappingURL=Hidden.js.map